export const CREDIT_COSTS = {
  GUEST_CHART: 1,
  RELATIONSHIP_OVERVIEW: 5,
  FULL_NATAL: 75,
  FULL_RELATIONSHIP: 60,
  ASK_STELLIUM: 1,
};
